<!-- <a mat-button matTooltip="View Project Group Role(s) for a User" (click)="openViewGroupRoleDialog()">
    <mat-icon aria-hidden="false" aria-label="icon">{{icon_view}}</mat-icon>
</a> -->
<a>
    <button mat-raised-button class="btn btn-squirrel" style="margin-top: 0px; height: 50px;" matTooltip="Alle Projektruppenrollen des Benutzers ansehen" (click)="openViewGroupRoleDialog()">Alle Gruppenrollen</button>
</a>
